/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Settings page components
import WalletEncryption from "layouts/profile/components/WalletEncryption";
import BackupRecovery from "layouts/profile/components/BackupRecovery";
import NetworkSettings from "layouts/profile/components/NetworkSettings";
import Preferences from "layouts/profile/components/Preferences";
import AboutWallet from "layouts/profile/components/AboutWallet";

function Settings() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox mt={4}>
        {/* Page Header */}
        <VuiBox mb={3}>
          <VuiTypography variant="h3" color="white" fontWeight="bold">
            Settings
          </VuiTypography>
          <VuiTypography variant="button" color="text">
            Manage your wallet security, network, and preferences
          </VuiTypography>
        </VuiBox>

        <Grid container spacing={3}>
          {/* Left Column - Security Settings */}
          <Grid item xs={12} lg={6}>
            <VuiBox mb={3}>
              <WalletEncryption />
            </VuiBox>
            <VuiBox>
              <BackupRecovery />
            </VuiBox>
          </Grid>

          {/* Right Column - General Settings */}
          <Grid item xs={12} lg={6}>
            <VuiBox mb={3}>
              <NetworkSettings />
            </VuiBox>
            <VuiBox mb={3}>
              <Preferences />
            </VuiBox>
            <VuiBox>
              <AboutWallet />
            </VuiBox>
          </Grid>
        </Grid>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Settings;
